export const defaultState = () => ({
  awaitingPayment: null,
  lockedOnSubmission: null,
  paymentOnSubmit: null,
  prepaymentRequired: null,
  readOnly: null,
  resubmissionPossible: null,
  showSubmitOnFirstTab: null,
  submissionPossible: null
});

const state = defaultState();

export default state;
